import { render, staticRenderFns } from "./customPcgView.vue?vue&type=template&id=3c907378&"
import script from "./customPcgView.vue?vue&type=script&lang=js&"
export * from "./customPcgView.vue?vue&type=script&lang=js&"
import style0 from "./customPcgView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports